import actions from './actions'

const initialState = {
  data: [],
  isFetching: false,
  error: '',
}

export default function reduxSagaReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_PRODUCTS: {
      return {
        ...state,
        isFetching: true,
        error: '',
      }
    }

    case actions.FETCH_PRODUCTS_SUCCESS: {
      return {
        ...state,
        data: action.data,
        isFetching: false,
        error: '',
      }
    }

    case actions.FETCH_PRODUCTS_ERROR: {
      return {
        ...state,
        isFetching: false,
      }
    }

    case actions.PRODUCT_SET: {
      return {
        ...state,
        data: action.data,
        isSaving: true,
        error: '',
      }
    }

    case actions.PRODUCT_ADD: {
      return {
        ...state,
        isSaving: true,
        error: '',
      }
    }

    case actions.PRODUCT_DEL: {
      return {
        ...state,
        isSaving: true,
        error: '',
      }
    }

    case actions.PRODUCT_SUCCESS: {
      return {
        ...state,
        isSaving: false,
        error: '',
      }
    }

    case actions.PRODUCT_ERROR: {
      return {
        ...state,
        isSaving: false,
      }
    }

    default: {
      return state
    }
  }
}
